import { Constants } from "../constants"
import {TokenService} from "@/services/token.service";
import jwtDecode from "jwt-decode";

let keycloak = undefined
let keycloakUser = undefined

class KeycloakUser {
    constructor(user) {
        this.email = user.email
        this.username = user.username
        this.name = user.name
        this.firstName = user.givenname
        this.lastName = user.familyname
        this.roles = user.roles
    }
}

const KeycloakService = {

    getConfig() {
        return {
            url: process.env.VUE_APP_KEYCLOAK_REALM,
            realm: process.env.VUE_APP_KEYCLOAK_AUTH_URL,
            clientId: 'api',
            oidcProvider: {
              authorization_endpoint:Constants.KEYCLOAK_AUTHORIZATION_ENDPOINT,
              token_endpoint: Constants.KEYCLOAK_ENDPOINT_TOKEN,
              end_session_endpoint: Constants.KEYCLOAK_END_SESSION_ENDPOINT,
              check_session_iframe: Constants.KEYCLOAK_END_CHECK_SESSION_IFRAME_ENDPOINT,
              userinfo_endpoint: Constants.KEYCLOAK_ENDPOINT_USERINFO,
            }
          }
    },

    getInitOptions () {
        return {
            onLoad: 'login-required',
            enableLogging: true,
            checkLoginIframe: false
        }
    },

    setKeycloak(keycloak, callback) {
        this.keycloak = keycloak
        keycloak.loadUserInfo().then((userinfo) => {
            this.keycloakUser = new KeycloakUser(userinfo)
            callback()
        })
    },

    isBookingAgent() {
        return this.keycloakUser.roles.includes('Booking agent')
    },

    isSuperUser() {
        return this.keycloakUser.roles.includes('Super user')
    },

    isWarehouseManager () {
        return this.keycloakUser.roles.includes('Warehouse management')
    },

    isAuthorized(roles) {
        return this.keycloakUser.roles.some(o => roles == undefined || roles && roles.includes(o))
    },

    isPreregistered () {
        const token = TokenService.getToken()
        const decodedToken = jwtDecode(token)
        const locations = decodedToken.locations
        if (locations === undefined) return false
        return locations.length > 0
    },

    getUser () {
        const token = TokenService.getToken()
        const decodedToken = jwtDecode(token)
        return decodedToken.sub
    },

    getUserEmail () {
        const token = TokenService.getToken()
        const decodedToken = jwtDecode(token)
        return decodedToken.email
    },

    hasAccess() {
        return this.keycloakUser.roles.some(r => ['Super user', 'Warehouse management', 'Warehouse planner', 'Booking agent'].includes(r))
    },

    logout() {
        this.keycloak.logout()
    },

}

export { KeycloakService }
